export function Ghost({ isVisible, children }) {
  if (!isVisible) {
    return null
  }

  return children
}
